(function () {
    if (window.customElements && customElements.get('avk-intro')) return;
    var KEY = 'avk-intro-seen';

    class AvkIntro extends HTMLElement {
      connectedCallback() {
        if (this._started) return;
        this._started = true;
        var d = this.dataset, html = document.documentElement, self = this;
        var design = !!(window.Shopify && window.Shopify.designMode);
        this.motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
        var reduce = this.motion && this.motion.matches;
        var seen = null;
        try {
          if (d.frequency === 'session') seen = sessionStorage.getItem(KEY);
          else if (d.frequency === 'once') seen = localStorage.getItem(KEY);
        } catch (e) {}
        if (reduce || (!design && seen) || document.querySelector('avk-intro[data-active]')) { this.remove(); return; }
        this.design = design;
        this.active = true;
        this.dataset.active = 'true';

        this.pace = parseFloat(d.pace) || 1;
        this.hold = isNaN(parseFloat(d.hold)) ? 1.6 : parseFloat(d.hold);
        this.phase = 'wait';
        this.timers = [];
        this.mark = this.querySelector('.avk-intro__mark');
        var vb = this.querySelector('svg').getAttribute('viewBox').trim().split(/\s+/).map(Number);
        this.aspect = vb[3] / vb[2];
        this.pending = this.querySelectorAll('.avk-intro__line').length;
        this.style.setProperty('--p', this.pace);
        this.hidden = false;
        this.previousFocus = document.activeElement;
        this.keyboardUsed = false;
        this.inertElements = [];
        var branch = this;
        while (branch.parentElement && branch !== document.body) {
          Array.from(branch.parentElement.children).forEach(function (el) {
            if (el === branch || /^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(el.tagName)) return;
            self.inertElements.push([el, el.inert]);
            el.inert = true;
          });
          branch = branch.parentElement;
        }
        html.classList.add('avk-intro-on');
        this.querySelector('.avk-intro__skip').focus({ preventScroll: true });

        this.onResize = function () { if (self.phase !== 'fly' && self.phase !== 'end') self.place(); };
        this.onKey = function (e) {
          self.keyboardUsed = true;
          if (e.key === 'Escape') self.skip();
          if (e.key === 'Tab') { e.preventDefault(); self.querySelector('.avk-intro__skip').focus(); }
        };
        this.onMotion = function (e) { if (e.matches) self.finish(); };
        this.onEnd = function (e) {
          if (e.animationName !== 'avkIntroStroke' || self.phase !== 'draw') return;
          if (--self.pending <= 0) { self.phase = 'hold'; self.later(function () { self.fly(false); }, self.hold * 1000); }
        };
        window.addEventListener('resize', this.onResize);
        window.addEventListener('keydown', this.onKey);
        if (this.motion && this.motion.addEventListener) this.motion.addEventListener('change', this.onMotion);
        this.addEventListener('animationend', this.onEnd);
        this.addEventListener('click', function () { self.skip(); });
        this.addEventListener('pointerdown', function () { self.keyboardUsed = false; });
        this.failsafe = setTimeout(function () { self.finish(); }, 21000);

        var logo = this.querySelector('.avk-intro__fill');
        var href = logo && logo.currentSrc || (logo && logo.src);
        var ready = new Promise(function (res) {
          if (!href) return res();
          var im = new Image();
          im.onload = function () { res(); };
          im.onerror = function () { self.finish(); res(); };
          im.src = href;
          self.later(function () { if (!im.complete || !im.naturalWidth) self.finish(); res(); }, 2500);
        });
        this.place();
        this.classList.add('is-placed');
        window.scrollTo(0, 0);
        ready.then(function () {
          if (self.done) return;
          self.later(function () { self.phase = 'draw'; self.classList.add('is-drawing'); }, 60);
        });
      }

      disconnectedCallback() { this.done = true; this.cleanup(); }

      later(fn, ms) { this.timers.push(setTimeout(fn, ms)); }

      place() {
        var vw = window.innerWidth, vh = window.innerHeight, mobile = vw < 750;
        var pct = (parseFloat(mobile ? this.dataset.sizeMobile : this.dataset.sizeDesktop) || (mobile ? 64 : 56)) / 100;
        var W = Math.min(vw * pct, mobile ? 340 : 980, (vh * 0.42) / this.aspect);
        var H = W * this.aspect;
        this.W = W; this.H = H;
        this.mark.style.width = W + 'px';
        this.mark.style.transform = 'translate(' + (vw - W) / 2 + 'px,' + (vh - H) / 2 + 'px)';
      }

      target() {
        var els = document.querySelectorAll('.header__logo-image, .header__logo-text');
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && getComputedStyle(els[i]).display !== 'none') return r;
        }
        return null;
      }

      fly(fast) {
        if (this.phase === 'fly' || this.phase === 'end' || !this.W) return;
        this.phase = 'fly';
        this.timers.forEach(clearTimeout); this.timers = [];
        var self = this, dur = (fast ? 1.1 : 2.2) * this.pace;
        var r = this.target(), s, tx, ty;
        if (r) {
          s = Math.min(r.width / this.W, r.height / this.H);
          tx = r.left + r.width / 2 - (this.W * s) / 2;
          ty = r.top + r.height / 2 - (this.H * s) / 2;
        } else {
          s = Math.min(180 / this.W, 44 / this.H);
          tx = (window.innerWidth - this.W * s) / 2; ty = 20;
        }
        document.documentElement.style.setProperty('--avk-intro-fly', dur + 's');
        this.style.setProperty('--avk-intro-fly', dur + 's');
        this.mark.style.transition = 'transform ' + dur + 's cubic-bezier(.76,0,.24,1), opacity .7s ease';
        this.mark.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
        this.classList.add('is-leaving');
        document.documentElement.classList.add('avk-intro-reveal');
        this.later(function () {
          self.phase = 'end';
          document.documentElement.classList.add('avk-intro-landed');
          self.mark.classList.add('is-fading');
          self.later(function () { self.finish(); }, 800);
        }, dur * 1000);
      }

      skip() {
        this.finish();
      }

      finish() {
        if (this.done) return;
        this.done = true;
        try {
          if (!this.design && this.dataset.frequency === 'session') sessionStorage.setItem(KEY, '1');
          else if (!this.design && this.dataset.frequency === 'once') localStorage.setItem(KEY, '1');
        } catch (e) {}
        this.remove();
      }

      cleanup() {
        (this.timers || []).forEach(clearTimeout);
        clearTimeout(this.failsafe);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('keydown', this.onKey);
        if (this.motion && this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotion);
        if (!this.active) return;
        this.active = false;
        (this.inertElements || []).forEach(function (item) { item[0].inert = item[1]; });
        var c = document.documentElement.classList;
        c.remove('avk-intro-on', 'avk-intro-reveal', 'avk-intro-landed');
        document.documentElement.style.removeProperty('--avk-intro-fly');
        var focus = this.previousFocus;
        if (!focus || focus === document.body || !focus.isConnected) focus = document.querySelector('.header__logo');
        if (this.keyboardUsed && focus && focus.focus) focus.focus({ preventScroll: true });
      }
    }

    customElements.define('avk-intro', AvkIntro);
  })();
